import { Component, OnInit } from '@angular/core';
import { BlogsService } from '../service/blogs.service';
import { Blog } from 'src/app/interfaces/blog';
import { ActivatedRoute } from '@angular/router';
import { ApplicationLanguages } from 'src/app/enums/lang';
import { registerLocaleData } from '@angular/common';
import ar from '@angular/common/locales/ar';

@Component({
  selector: 'app-blog-page',
  templateUrl: './blog-page.component.html',
  styleUrls: ['./blog-page.component.scss'],
})
export class BlogPageComponent implements OnInit {
  latestTwoBlogs: Blog[] = [];
  blog?: Blog = undefined;
  id: number = -1;

  currentLang = localStorage.getItem('lang') || ApplicationLanguages.Ar;
  ApplicationLanguages = ApplicationLanguages;

  constructor(
    private blogsService: BlogsService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    registerLocaleData(ar);
    this.getBlogsData();

    this.route.paramMap.subscribe((params) => {
      this.id = Number(params.get('id'));
      this.getBlogsData();
    });
  }

  getBlogsData() {
    this.blogsService.getData().subscribe({
      next: (response: Blog[]) => {
        this.blog = response.find((blog) => blog.id === this.id);

        let firstTwoBlogs = response.slice(0, 2);
        if (this.blog && firstTwoBlogs.some((b) => b.id === this.blog?.id)) {
          firstTwoBlogs = [
            ...firstTwoBlogs.filter((b) => b.id !== this.blog?.id),
            response[2],
          ];
        }
        this.latestTwoBlogs = firstTwoBlogs;
      },
      error: (error: any) => {
        console.error('Error fetching data:', error);
      },
    });
  }
}
